import { createReducer } from 'src/utils/create-reducer';

import { LoadProfilePage } from './actions';
import { ProfileSectionState } from './types';

const initialState: ProfileSectionState = {
  currentUser: undefined,
  currentWorkspace: undefined,
};

export const sectionReducer = createReducer(initialState, {
  [LoadProfilePage.REQUEST](state) {
    return {
      ...initialState,
      ...state,
    };
  },
  [LoadProfilePage.SUCCESS](state, action) {
    return {
      ...state,
      ...action.payload,
    };
  },
});
